/* FS product: gallery, quantity, variant picker (updates price, availability, media, URL) */
(() => {
  const money = (cents) => {
    const fmt = window.fsMoneyFormat || '{{amount}}';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const grouped = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', `${grouped}.${d}`)
      .replace('{{amount_no_decimals}}', grouped)
      .replace('{{amount_with_comma_separator}}', `${i.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${d}`)
      .replace('{{amount_no_decimals_with_comma_separator}}', i.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_with_space_separator}}', `${i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${d}`)
      .replace('{{amount_no_decimals_with_space_separator}}', i.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
  };

  /* Gallery */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const slides = [...g.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...g.querySelectorAll('[data-gallery-thumb]')];
    const show = (id) => {
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === String(id)));
      const t = thumbs.find((x) => x.dataset.mediaId === String(id));
      t?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    const current = () => slides.findIndex((s) => s.classList.contains('is-active'));
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.mediaId)));
    g.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(slides[(current() - 1 + slides.length) % slides.length].dataset.mediaId));
    g.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(slides[(current() + 1) % slides.length].dataset.mediaId));
    let sx = 0;
    const main = g.querySelector('.fs-gallery__main');
    main?.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    main?.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40 && slides.length > 1) show(slides[(current() + (dx < 0 ? 1 : -1) + slides.length) % slides.length].dataset.mediaId);
    }, { passive: true });
    g.showMedia = show;
  });

  /* Quantity */
  document.querySelectorAll('.fs-qty').forEach((q) => {
    const input = q.querySelector('[data-qty]');
    q.querySelector('[data-qty-minus]')?.addEventListener('click', () => (input.value = Math.max(1, Number(input.value) - 1)));
    q.querySelector('[data-qty-plus]')?.addEventListener('click', () => (input.value = Number(input.value) + 1));
  });

  /* Variant picker */
  if (!customElements.get('fs-variant-picker')) {
    customElements.define(
      'fs-variant-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
          this.options = [...this.querySelectorAll('.fs-option')];
          this.idInput = this.querySelector('[data-variant-id]');
          this.addBtn = this.querySelector('[data-add-button]');
          this.addText = this.querySelector('[data-add-text]');
          const root = this.closest('[data-fs-product]') || document;
          this.priceNow = root.querySelector('[data-price-now]');
          this.priceWas = root.querySelector('[data-price-was]');
          this.priceBadge = root.querySelector('[data-price-badge]');
          this.priceWrap = root.querySelector('[data-price]');
          this.gallery = root.querySelector('[data-gallery]');
          this.querySelectorAll('[data-option-value]').forEach((el) => el.addEventListener('change', () => this.update()));
          this.markAvailability();
        }
        selected() {
          return this.options.map((o) => {
            const r = o.querySelector('input[data-option-value]:checked');
            return r ? r.value : o.querySelector('select[data-option-value]')?.value;
          });
        }
        find() {
          const sel = this.selected();
          return this.variants.find((v) => sel.every((val, i) => v.options[i] === val));
        }
        update() {
          const v = this.find();
          this.options.forEach((o) => {
            const label = o.querySelector('[data-option-selected]');
            const r = o.querySelector('input[data-option-value]:checked');
            if (label) label.textContent = r ? r.value : o.querySelector('select[data-option-value]')?.value;
          });
          if (!v) {
            this.setButton(false, 'Unavailable');
            return;
          }
          this.idInput.value = v.id;
          this.idInput.disabled = !v.available;
          this.setButton(v.available, v.available ? 'Add to cart' : 'Sold out');
          if (this.priceNow) this.priceNow.textContent = money(v.price);
          const sale = v.compare_at_price && v.compare_at_price > v.price;
          if (this.priceWas) {
            this.priceWas.hidden = !sale;
            if (sale) this.priceWas.textContent = money(v.compare_at_price);
          }
          if (this.priceBadge) {
            this.priceBadge.hidden = !sale;
            if (sale) this.priceBadge.textContent = `Save ${Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100)}%`;
          }
          this.priceWrap?.classList.toggle('is-sale', !!sale);
          if (v.featured_media && this.gallery?.showMedia) this.gallery.showMedia(v.featured_media.id);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
          this.markAvailability();
        }
        setButton(enabled, text) {
          if (!this.addBtn) return;
          this.addBtn.disabled = !enabled;
          if (this.addText) this.addText.textContent = text;
        }
        markAvailability() {
          /* grey out option values that have no available variant given the other selections */
          const sel = this.selected();
          this.options.forEach((o, i) => {
            o.querySelectorAll('[data-option-value]').forEach((el) => {
              const values = el.tagName === 'SELECT' ? [...el.options] : [el];
              values.forEach((val) => {
                const candidate = [...sel];
                candidate[i] = val.value;
                const ok = this.variants.some((v) => v.available && candidate.every((x, k) => v.options[k] === x));
                (val.closest('label') || val).classList?.toggle('is-unavailable', !ok);
              });
            });
          });
        }
      }
    );
  }
})();
